import type { EyeStyleOptions } from './AppearanceDefinitions';

/** NPC art keeps its selected expression and dark-eye finish. Equal sockets
 * are the default; an authored profile or another library style stays explicit. */
export const NPC_DEFAULT_EYE_STYLE: Readonly<EyeStyleOptions> = Object.freeze({ style: 'matched' });

export function withNpcEyes<T extends { eyeStyle?: EyeStyleOptions }>(appearance: T): T {
  return appearance.eyeStyle ? appearance : { ...appearance, eyeStyle: NPC_DEFAULT_EYE_STYLE };
}
